import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer
      className="bg-[color:var(--kw-black)] text-white"
      data-testid="site-footer"
    >
      <div className="container-kw py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="font-display text-2xl font-bold">
              King&apos;s Wake Digital
            </div>
            <p className="mt-3 text-sm text-white/60 max-w-xs leading-relaxed">
              A product company building and operating platforms with clarity,
              fairness, and purpose.
            </p>
          </div>

          <div>
            <div className="eyebrow text-white/50">Products</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <span className="text-white/80">CoinsFlu</span>
                <span className="ml-2 text-xs text-white/40">
                  Coming soon
                </span>
              </li>
              <li>
                <a
                  href="https://harday.co.in/dashboard"
                  target="_blank"
                  rel="noreferrer"
                  className="text-white/80 hover:text-[color:var(--kw-yellow)] transition-colors"
                  data-testid="footer-harday-link"
                >
                  Harday ↗
                </a>
              </li>
            </ul>
          </div>

          <div>
            <div className="eyebrow text-white/50">Company</div>
            <ul className="mt-4 space-y-2 text-sm">
              <li>
                <a
                  href="#about"
                  className="text-white/80 hover:text-[color:var(--kw-yellow)] transition-colors"
                >
                  About
                </a>
              </li>
              <li>
                <a
                  href="#contact"
                  className="text-white/80 hover:text-[color:var(--kw-yellow)] transition-colors"
                >
                  Contact
                </a>
              </li>
              <li>
                <Link
                  to="/privacy"
                  className="text-white/80 hover:text-[color:var(--kw-yellow)] transition-colors"
                  data-testid="footer-privacy-link"
                >
                  Privacy Policy
                </Link>
              </li>
              <li className="pt-3">
                <div className="text-xs font-semibold uppercase tracking-wider text-white/40">Jantaquid</div>
              </li>
              <li>
                <Link
                  to="/jantaquid/privacy-policy"
                  className="text-white/80 hover:text-[color:var(--kw-yellow)] transition-colors"
                  data-testid="footer-jantaquid-privacy-link"
                >
                  Jantaquid Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/jantaquid/terms-and-conditions"
                  className="text-white/80 hover:text-[color:var(--kw-yellow)] transition-colors"
                  data-testid="footer-jantaquid-terms-link"
                >
                  Jantaquid Terms &amp; Conditions
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-white/80 hover:text-[color:var(--kw-yellow)] transition-colors"
                  data-testid="footer-terms-link"
                >
                  Terms &amp; Conditions
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div className="text-xs text-white/50">
            © {new Date().getFullYear()} King&apos;s Wake Digital Pvt. Ltd. All
            rights reserved.
          </div>
          <div className="text-xs text-white/50">Punjab, India — 141412</div>
        </div>
      </div>
    </footer>
  );
}
